<template>
  <el-scrollbar
    ref="scrollbar"
    v-bind="$props"
    @scroll="handleScroll">
    <slot />
  </el-scrollbar>
</template>

<script>
export default {
  name: 'BaseScrollbar',
  props: {
    viewClass: {
      type: String,
    },
    scrollPosition: {
      // from 0 to 1
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      emitted: false,
    };
  },
  methods: {
    handleScroll() {
      const scrollbar = this.$refs.scrollbar;
      this.$refs.scrollbar.update()
      if (!scrollbar.native) {
        const scrollPercentage = Math.round((scrollbar.moveY * (parseFloat(scrollbar.sizeHeight) / 100)));
        this.$emit('handleScroll', scrollPercentage + (parseFloat(scrollbar.sizeHeight) / 2))
        if (scrollPercentage < 100) {
          this.emitted = false;
        }
        if (scrollPercentage <= 20) {
          this.$emit('scrollystart');
        }
        if (scrollPercentage + parseFloat(scrollbar.sizeHeight) >= 80) {
          this.$emit('scrollyend');
        }
      }
    },
  },
  mounted() {
    if (this.scrollPosition > 0 && this.scrollPosition < 1) {
      this.$nextTick(() => this.$refs.scrollbar.wrap.scrollTop = this.$refs.scrollbar.wrap.scrollHeight * this.scrollPosition)
    }
  }
};
</script>
